
import { useParams } from "react-router-dom"
import { useState, useEffect } from 'react'
import { Card, Container, Grid, Typography } from "@mui/material"
import Loading from "../../load/loading";
import api from "../../services/api";
import { useSelector } from 'react-redux';
import Date from "../../utils/date";
import HeaderSession from "../../utils/headerSession";
import TextoFormatado from "../../utils/textoFormatado";
import ResponseExpediente from "./responseExpediente";
import CreateObservacaoExpediente from "./createObservacaoExpediente";
import { makeStyles } from "@material-ui/core";
import NavLateral from "./navLateral";

const useStyles = makeStyles((theme) => ({
    grid1: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",

        [theme.breakpoints.up("md")]: {
            // width: '100%',
            height: "100%",
            position: "sticky",
            top: 70,
        },
    },
    grid2: {
        flexGrow: 1,
        marginLeft: 15,
        width: 500,
        zIndex: 1,
    },
}));

export default function GestExpediente({ element: component, ...rest }) {
    const classes = useStyles();
    let { id } = useParams()
    const [expediente, setexpediente] = useState('')
    const user = useSelector(state => state.account.user);
    const [update, setUpdate] = useState(false)


    useEffect(() => {
        api.get(`/expediente/${id}`)
            .then(response => {
                // console.log(response)
                setexpediente(response.data.expediente);
            }).catch(error => {
                // console.log(error)
                // if (error.response.status === 500) {
                //     setMessageError('Reclamação não encontrada')
                //     window.setTimeout(() => {
                //         navigate(-1)
                //     }, 1000);
                // }
            })
    }, [id, update])


    return (
        expediente
            ?

            <Container>
                <HeaderSession title={'GESTÃO DE EXPEDIENTE'} />

                <Grid container>
                    <Grid item className={classes.grid1}>
                        <NavLateral
                            observacoesFeitas={expediente?.observacoes}
                            expediente={expediente}
                            setUpdate={setUpdate}
                        />
                    </Grid>

                    <Grid xs item className={classes.grid2} style={{ marginLeft: 15 }}>
                        {/* {React.cloneElement(component, {
                                expediente: expediente,
                            })} */}


                        <Card style={{ padding: 20, marginBottom: 10, }}>
                            <Typography variant="body1" lineHeight={1.5}>
                                Número de Expediente: {expediente?.numero}
                                <br />
                                <strong>Tipo de documento:</strong> {expediente?.tipoDocumento?.designacao}
                                <br />
                                <strong>Assunto:</strong> {expediente?.assunto}
                                <br />
                                <strong>Nome:</strong> {expediente?.nome}
                                <br />
                                <strong>Contacto:</strong> {expediente?.tel}
                                <br />
                                <strong>Email:</strong> {expediente?.email}
                                <br />
                                <strong>Data:</strong> <Date date={expediente?.createdAt} />
                            </Typography>

                            <br />
                            <Typography variant="body1" lineHeight={1.5}> <strong>REMITENTE</strong></Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Tipo:</strong> {expediente?.tipoRemetente}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Nome:</strong> {expediente?.remetidoPor?.nome}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Contacto:</strong> {expediente?.remetidoPor?.tel}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>Email:</strong> {expediente?.remetidoPor?.email}</Typography>
                            <Typography variant="body1" lineHeight={1.5}> <strong>B.I:</strong> {expediente?.remetidoPor?.bi}</Typography>
                        </Card>

                        <Card style={{ padding: 20, marginBottom: 10, }}>
                            <Typography align="center" variant="body1" style={{ margin: 10 }}>
                                Exposição
                            </Typography>
                            <TextoFormatado texto={expediente?.descricao} />
                        </Card>


                        <Card style={{ padding: 20 }}>
                            <Typography variant="subtitle1" style={{ margin: 10 }}>
                                Documento anexado:
                                <br />
                                <a target="_blank" href={expediente?.anexo} >{expediente?.anexo ? 'Anexo' : ''} </a>
                                <br />
                                <a target="_blank" href={expediente?.remetidoPor?.anexoBi} >{expediente?.remetidoPor?.anexoBi ? 'B.I Remetente' : ''} </a>
                            </Typography>
                            <iframe
                                id="pdfIframeExpediente"
                                title={`PDF Viewer`}
                                // src={[expediente?.anexo, expediente?.remetidoPor?.anexoBi]}
                                src={[expediente?.anexo]}
                                width="100%"
                                height="800px"
                                style={{ border: 'none' }}
                            />
                        </Card>

                        <CreateObservacaoExpediente
                            userId={user?._id}
                            expedienteId={id}
                            observacoes={expediente?.observacoes}
                            setUpdate={setUpdate}
                        />

                        <ResponseExpediente
                            userId={user?._id}
                            expediente={expediente}
                            setUpdate={setUpdate}
                        />
                    </Grid>
                </Grid>

            </Container>
            :
            <Loading text={'A carregar expediente.'} />
    )
}